import { colors, Icon, IconName } from "@ch/ui/pro";
import { View } from "react-native";

import { tailwind } from "src/foundations/styles";
import { Paragraph } from "src/foundations/ui";
import Accordion from "src/ui/components/Accordion/Accordion";
import AccordionDetails from "src/ui/components/Accordion/AccordionDetails";
import AccordionSummary from "src/ui/components/Accordion/AccordionSummary";

type NavPanelSectionProps = {
  title: string;
  iconName: IconName;
  defaultExpanded?: boolean;
  children: React.ReactNode;
};

function NavPanelSection(props: NavPanelSectionProps) {
  return (
    <Accordion accessibilityLabel={props.title} defaultExpanded={props.defaultExpanded} hideBorder>
      <AccordionSummary verticalPadding="sm">
        <View style={tailwind("flex-row")}>
          <Icon name={props.iconName} size="sm" color={colors.gray["800"]} />
          <View style={tailwind("ml-2")}>
            <Paragraph level={2}>{props.title}</Paragraph>
          </View>
        </View>
      </AccordionSummary>
      <AccordionDetails noBottomPadding>{props.children}</AccordionDetails>
    </Accordion>
  );
}

export default NavPanelSection;
